module.exports = __webpack_public_path__ + "static/media/SN.9a686d10.png";